import { DashboardAction } from "../actions";
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";
// import AsyncStorage from '@react-native-community/async-storage';
const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
  ?.rmx_company?.id;
export default class DashboardMiddleWare {
  static *DashboardCount(action) {
    const { params } = action;
    try {
      let res = yield ApiCaller.Get(`rmx_companies/${params}/counts`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(DashboardAction.getCountSuccess(res.data.data.orders));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getCountError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getCountError());
    }
  }

  static *DashboardOrders(action) {
    const { params, id } = action;
    const obj = { ...params };
    if (!obj.start_date || !obj.end_date) {
      delete obj.start_date;
      delete obj.end_date;
    }
    const qureyParams = new URLSearchParams(obj).toString();

    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${id}/orders?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      console.log("orderRes-->", res);

      if (res.status == 200) {
        yield put(
          DashboardAction.getOrderSuccess(res.data.data, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getOrderError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderError());
    }
  }

  static *AllCustomer(action) {
    const { params, id } = action;

    const qureyParams = new URLSearchParams(params).toString();
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/contractors?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(
          DashboardAction.getAllCustomerSuccess(res.data.data, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(DashboardAction.getAllCustomerError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getAllCustomerError());
    }
  }

  static *AllowCustomer(action) {
    const { params, cb, payload } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/contractors/${params}/allow`,
        {},
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(
          DashboardAction.allowCustomerSuccess(res.data.data, res.data.meta)
        );
        yield put(DashboardAction.getAllCustomerReq(payload));

        cb() && cb();
      } else {
        yield put(DashboardAction.allowCustomerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.allowCustomerError());
    }
  }

  static *RestrictCustomer(action) {
    const { params, payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;

    try {
      let res = yield ApiCaller.Delete(
        `rmx_companies/${companyId}/contractors/${params}/restrict`,
        {},
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(
          DashboardAction.restrictCustomerSuccess(res.data.data, res.data.meta)
        );
        yield put(DashboardAction.getAllCustomerReq(payload));
        cb() && cb();
      } else {
        yield put(DashboardAction.restrictCustomerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.restrictCustomerError());
    }
  }

  static *getOrderDetailById(action) {
    const { id, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(`rmx_companies/${companyId}/orders/${id}`, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        res.data.data.driver_orders?.sort((a, b) => {
          if (a.is_lead && !b.is_lead) {
            return -1; // `a` should come before `b`
          } else if (!a.is_lead && b.is_lead) {
            return 1; // `b` should come before `a`
          } else {
            return 0; // Maintain the original order
          }
        });
        yield put(DashboardAction.getOrderDetailSuccess(res.data.data));
        cb() && cb();
      } else {
        yield put(DashboardAction.getOrderDetailError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderDetailError());
    }
  }

  static *orderAprovalMiddleWare(action) {
    const { id, cb, params, logId } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res;
      if (params == "dispatch") {
        res = yield ApiCaller.Post(
          `rmx_companies/${companyId}/orders/${id}/${params}`,
          { logistics_partner_id: logId }
        );
        if (res.status === 200) {
          if (params == "dispatch") {
            info("success", "order dispatched successfully");
          }
        }
      } else {
        res = yield ApiCaller.Put(
          `rmx_companies/${companyId}/orders/${id}/${params}`,
          {
            "Content-Type": "application/json",
          }
        );
      }

      if (res.status == 200 || res.status == 204) {
        yield put(DashboardAction.OrderApprovalSuccess());

        cb() && cb();
      } else {
        yield put(DashboardAction.OrderApprovalError());
        info("error", res.data.error.message || "Error Occured");
      }
    } catch (err) {
      yield put(DashboardAction.OrderApprovalError());
    }
  }
  static *deleteDocMiddleWare(action) {
    const { orderId, docId, cb, callBack } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Delete(
        `rmx_companies/orders/${orderId}/${cb.params}/${docId}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(DashboardAction.getOrderDetailReq(orderId));
        info("success", "File Deleted Successfully!");

        cb() && cb();
        callBack() && callBack();
      } else {
        yield put(DashboardAction.getOrderDetailError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getOrderDetailError());
    }
  }

  static *uploadDocMiddleWare(action) {
    const { orderId, payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/orders/${orderId}/${cb.params}`,
        formData
      );
      if (res.status == 200) {
        yield put(DashboardAction.getOrderDetailSuccess(res.data.data));
        yield put(DashboardAction.uploadDocSuccess());

        info("success", "File Uploaded Successfully!");

        cb() && cb();
      } else {
        yield put(DashboardAction.uploadDocError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.uploadDocError());
    }
  }
  static *getNotificationMiddleWare() {
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(`rmx_companies/${companyId}/notifications`);
      if (res.status == 200) {
        yield put(DashboardAction.getNotificationSuccess(res.data.data));
      } else {
        yield put(DashboardAction.getNotificationError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getNotificationError());
    }
  }
  static *markAsReadMiddleWare(action) {
    const { notificationId } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Put(
        `notifications/${notificationId}/mark_read`
      );
      if (res.status == 200) {
      } else {
        yield put(DashboardAction.getNotificationError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getNotificationError());
    }
  }
  static *getLogisticsMiddleWare(action) {
    const { notificationId } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(
        `logistics_partners_active?per_page=${10000}&rmx_company_id=${companyId}`
      );
      if (res.status == 200) {
        yield put(DashboardAction.getLogisticsSuccess(res.data.data));
      } else {
        yield put(DashboardAction.getLogisticsError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogisticsError());
    }
  }
  static *getLogPartberMiddleWare(action) {
    const { notificationId } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/logistics_partners`
      );
      if (res.status == 200) {
        yield put(DashboardAction.getLogPartnerSuccess(res.data.data));
      } else {
        yield put(DashboardAction.getLogPartnerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogPartnerError());
    }
  }

  static *markAsFavMiddleWare(action) {
    const { id } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/logistics_partners/${id}`
      );
      if (res.status == 201) {
        yield put(DashboardAction.getLogPartnerReq());
        yield put(DashboardAction.getLogisticsReq());
      } else {
        yield put(DashboardAction.getLogPartnerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.getLogPartnerError());
    }
  }


  static *deletLogisticsMiddleWare(action) {
    const { id } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Delete(
        `rmx_companies/${companyId}/logistics_partners/${id}`
      );
      if (res.status == 200) {
        yield put(DashboardAction.getLogisticsReq());
        yield put(DashboardAction.getLogPartnerReq());

      } else {
        yield put(DashboardAction.deleteLogisticsPartnerError());
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(DashboardAction.deleteLogisticsPartnerError());
    }
  }
}
